module.exports = __webpack_public_path__ + "static/axept-acb8f0e5c14b6a871e1e293bf4d97e8d.png";